import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from '../Router'
import { DefaultButtonWithText, Logo } from '../App/Components'
import { StyledScrollView } from '../App/Components/AppContainer'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { clearError } from './store'
import {
  ErrorContainer,
  ErrorHeading,
  ErrorMessage,
  ErrorContext,
} from './style'

export const ErrorPage = () => {
  const { t } = useTranslation()
  const { establishmentId } = useParams<{ [key: string]: string }>()
  const dispatch = useAppDispatch()
  const settings = useAppSelector((state) => state.settings.values)
  const errorState = useAppSelector((state) => state.error)

  const fontColor = settings?.fontColor || '#333'
  const bgColor = settings?.backgroundColor || '#fff'
  const highlightColor = settings?.highlightColor || '#000'

  return (
    <StyledScrollView>
      <Logo />
      <ErrorContainer>
        <ErrorHeading fontcolor={highlightColor}>
          {t('Something went wrong')}
        </ErrorHeading>
        <ErrorMessage fontcolor={fontColor}>
          {errorState?.message || t('An unexpected error occurred. Please try again.')}
        </ErrorMessage>
        {errorState?.context ? (
          <ErrorContext fontcolor={fontColor}>
            {errorState.context}
          </ErrorContext>
        ) : null}
      </ErrorContainer>
      <DefaultButtonWithText
        backgroundcolor={bgColor}
        fontcolor={highlightColor}
        hoversensitive
        onPress={() => {
          dispatch(clearError())
          window.location.href = `/${establishmentId}`
        }}
      >
        {t('Go back to home')}
      </DefaultButtonWithText>
    </StyledScrollView>
  )
}
